
import CommonUtils from '@/utils/common-utils';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import LessonListItem from '@/components/lessonlists/LessonListItem.vue';
import ld from 'lodash';
import { Debounce } from 'vue-debounce-decorator';
import LessonListsTable from '@/components/lessonlists/LessonListsTable.vue';
import PageLifeCycleMixin from '@/mixins/page-lifecycle-mixin';
const plans = namespace('plans');
const lessonsearch = namespace('lessonsearch');

@Component({
  mixins: [PageLifeCycleMixin],
  components: {
    LessonListItem,
    LessonListsTable
  }
})
export default class LessonSearch extends Vue {
  editMode = false;
  selectedRows = [];

  headers = [
    { sortable: false, width: '1%', value: 'action' },
    { text: this.$t('classLabel'), value: 'searchClassName', width: '13%', sortable: false },
    { text: this.$t('yearLabel'), value: 'searchYear', width: '10%', sortable: false },
    { text: this.$t('dateLabel'), value: 'searchDate', width: '10%', sortable: false },
    { text: this.$t('dayLabel'), value: 'searchDayOfWeek', width: '10%', sortable: false },
    { text: this.$t('lessonLabel'), value: 'lessonTitle', width: '70%', sortable: false, align: 'center' }
  ];

  $refs!: {
    lessonListsTable:LessonListsTable
  }

  @plans.Action
  getSearchedLessons!: (params?:any) => Promise<any>;

  @lessonsearch.Action
  clearSearchFilters!: () => Promise<any>;

  @plans.Getter('getSearchLessonArray')
  searchLessonArray!: Array<any>;

  @lessonsearch.Action
  loadYearsAndClasses!: () => Promise<any>;

  @lessonsearch.State
  searchSchoolYearId!: number;

  @lessonsearch.State
  searchSubjectId!: number;

  @lessonsearch.State
  searchBankId!: number;

  @lessonsearch.State
  searchStartDate!: string;

  @lessonsearch.State
  searchEndDate!: string;

  @lessonsearch.State
  searchDeleted!: boolean;

  get lessonArray(): Array<any> {
    return this.searchLessonArray;
  }

  set lessonArray(val: Array<any>) {
    this.$store.commit('plans/setSearchLessonArray', val);
  }

  get search(): string {
    return this.$store.state.lessonsearch.searchLessonString;
  }

  set search(val: string) {
    this.$store.commit('lessonsearch/setSearchLessonString', val);
  }

  get typing() {
    return this.$store.state.lessonsearch.typing;
  }

  set typing(value: boolean) {
    this.$store.commit('lessonsearch/setTyping', value);
  }

  get searching() {
    return this.$store.state.lessonsearch.searching;
  }

  set searching(value: boolean) {
    this.$store.commit('lessonsearch/setSearching', value);
  }

  toggleEditMode() {
    this.editMode = !this.editMode;
    if (this.editMode === false) {
      this.selectedRows = [];
    }
  }

  async doSearchLesson(resetList:boolean) {
    if (CommonUtils.hasText(this.search)) {
      if (resetList) CommonUtils.showLoading();
      this.searching = true;
      this.getSearchedLessons({
        searchString: this.search,
        searchSchoolYearId: this.$store.state.lessonsearch.searchSchoolYearId ?? -1,
        searchStartDate: this.$store.state.lessonsearch.searchStartDate ?? '',
        searchEndDate: this.$store.state.lessonsearch.searchEndDate ?? '',
        searchSubjectId: this.$store.state.lessonsearch.searchSubjectId ?? 0,
        searchBankId: this.$store.state.lessonsearch.searchBankId ?? 0,
        searchDeleted: this.$store.state.lessonsearch.searchDeleted ?? false
      }).then((resp:any) => {
        this.$refs.lessonListsTable.localInfiniteScrollResetAllowed = resetList;
        this.lessonArray = ld.cloneDeep(resp.dataObjects);
        if (resetList) CommonUtils.hideLoading();
        return Promise.resolve();
      })
    }
    return Promise.resolve();
  }

  reset() {
    this.clearSearchFilters().then(() => {
      this.$eventBus.$emit('closeSubPage');
    });
  }

  @Watch('search')
  @Debounce(500)
  onSearchChange() {
    this.typing = false;
  }

  @Watch('searchSchoolYearId')
  @Watch('searchSubjectId')
  @Watch('searchBankId')
  @Watch('searchStartDate')
  @Watch('searchEndDate')
  @Watch('searchDeleted')
  onFilterChange() {
    if (!this.typing && this.searching) {
      this.doSearchLesson(true);
    }
  }

  mounted() {
    CommonUtils.showLoading();
    this.loadYearsAndClasses().finally(() => {
      CommonUtils.hideLoading();
    });

    if (!CommonUtils.hasText(this.search) && this.lessonArray.length === 0) {
      this.reset();
    }
    const _this = this;
    _this.$refs.lessonListsTable.localInfiniteScrollResetAllowed = true;
    this.populateListData();
    this.$nextTick(() => {
      _this.$eventBus.$on('lessonHasBeenSave', async () => {
        _this.$eventBus.$emit('showLessonListLoading');
        await _this.doSearchLesson(false);
        _this.$eventBus.$emit('hideLessonListLoading');
      });
    });
  }

  destroyed() {
    this.$eventBus.$off('lessonHasBeenSave');
  }

  populateListData() {
    const tempLessonArray = ld.cloneDeep(this.lessonArray);
    this.lessonArray = [];
    this.lessonArray = tempLessonArray;
  }
}
